export default "__VITE_ASSET__DLnLigx5__"